import { sendMail } from 'services/mail.services';
import {
    MAIL_SEND_REQUESTED,
    MAIL_SEND_SUCCEFFSUL,
    MAIL_SEND_FAILED,
} from './actionTypes';

export default function sendContactForm(payload, add_coach_application) { // eslint-disable-line

  return (dispatch) => {
    dispatch({
      type: MAIL_SEND_REQUESTED,
    });
    sendMail(payload, add_coach_application)
          .then((result) => {
            dispatch({
              type: MAIL_SEND_SUCCEFFSUL,
              result,
            });
          })
          .catch((err) => {
            dispatch({
              type: MAIL_SEND_FAILED,
              error: err,
            });
          });
  };
}



// WEBPACK FOOTER //
// ./src/components/SendGrid/actions.js